'use client';


import Icon from '@/components/ui/AppIcon';

interface TrustMetric {
  id: string;
  icon: string;
  label: string;
}

const trustMetrics: TrustMetric[] = [
  { id: 'process', icon: 'DocumentCheckIcon', label: 'Tydelig og forståelig prosess' },
  { id: 'security', icon: 'ShieldCheckIcon', label: 'Fokus på sikker håndtering' },
  { id: 'commitment', icon: 'CheckBadgeIcon', label: 'Ingen forpliktelse ved forespørsel' },
  { id: 'communication', icon: 'ChatBubbleLeftRightIcon', label: 'Personlig oppfølging' },
];

const TrustIndicatorBar = () => {
  return (
    <div id="trust-indicator-bar" className="bg-card py-8 lg:py-12">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid grid-cols-2 gap-6 lg:grid-cols-4 lg:gap-8">
          {trustMetrics.map((metric) => (
            <div
              key={metric.id}
              className="flex flex-col items-center space-y-2 text-center transition-transform duration-300 hover:scale-105"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
                <Icon 
                  name={metric.icon as any} 
                  size={24} 
                  variant="outline"
                  className="text-primary"
                />
              </div>
              <div className="font-body text-sm font-medium text-muted-foreground lg:text-base">
                {metric.label}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-4 border-t border-border pt-8 lg:gap-8">
          <div className="flex items-center space-x-2">
            <Icon name="ShieldCheckIcon" size={20} variant="solid" className="text-success" />
            <span className="font-body text-sm font-medium text-foreground">Norsk registrert selskap</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="LockClosedIcon" size={20} variant="solid" className="text-success" />
            <span className="font-body text-sm font-medium text-foreground">Sikker betaling</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="CheckBadgeIcon" size={20} variant="solid" className="text-success" />
            <span className="font-body text-sm font-medium text-foreground">100% tilfredsgaranti</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustIndicatorBar;